module.exports = __webpack_public_path__ + "static/media/Location.9363f822.svg";